import React, { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAnswerers } from "../features/answerer/hooks/useAnswerers";
import { ProfileImage } from "@twioku/common_components";
import { SpinAnimation } from "@twioku/common_components";
import { Button } from "@twioku/common_components";
import { Path } from "../routes/PagePath";
import DescriptionImage1 from "../assets/twioku-description1.png";
import DescriptionImag2 from "../assets/twioku-description2.png";
import DescriptionImag3 from "../assets/twioku-description3.png";
import ChevronsRight from "../assets/chevrons_right.svg";
import { ImageSlider } from "../components/ImageSlider";

export const AnswerersPage: React.FC = () => {
    const { answerers, isLoading } = useAnswerers();
    const navigate = useNavigate();

    const sliderImages = useMemo(
        () => [DescriptionImage1, DescriptionImag2, DescriptionImag3],
        []
    );

    if (isLoading)
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <SpinAnimation />
            </div>
        );

    return (
        <>
            {answerers.length > 0 ? (
                answerers.map((answerer) => {
                    return (
                        <div key={answerer.answererId} className="border-b-2">
                            <Link
                                to={"/answerer/" + answerer.answererId}
                                className="mx-5 flex justify-between py-3"
                            >
                                <div className="flex">
                                    <ProfileImage
                                        src={answerer.profileImagePath}
                                        size="small"
                                    />
                                    <span className="my-auto block px-3">
                                        {answerer.name}
                                    </span>
                                </div>
                                <div className="flex">
                                    {!answerer.isPrivacyAndUsageTermsAgreed && (
                                        <div
                                            className={`my-auto flex h-6 w-auto justify-center rounded-full bg-yellow-100 px-2`}
                                        >
                                            <div className="my-auto w-max text-sm text-yellow-500">
                                                ※開始前
                                            </div>
                                        </div>
                                    )}
                                    <img
                                        className="w-7"
                                        src={ChevronsRight}
                                        alt="詳細へ進む"
                                    />
                                    <div className="my-auto"></div>
                                </div>
                            </Link>
                        </div>
                    );
                })
            ) : (
                <div className="mx-6">
                    <div className="mt-12">
                        <h1 className="mx-auto mt-8 text-center text-xl font-bold">
                            ようこそツイオクへ！
                            <br />
                            親御さまをツイオクに招待しましょう
                        </h1>
                        <ImageSlider
                            images={sliderImages}
                            alt="ツイオク紹介画像"
                            imageClassName="mx-auto w-full md:w-3/4 md:max-w-2xl"
                        />
                    </div>
                    <p className="my-10 text-gray-500">
                        ツイオクは親子の昔の記憶についてやりとりできるサービスです。
                    </p>
                    <ol className="list-outside list-decimal space-y-2 pl-5 text-gray-500">
                        <li>
                            ツイオクから親御さまあてに、昔の記憶について質問が送られます。
                        </li>
                        <li>
                            親御さまが返信いただいた思い出があなたに届き、コメントやイイネのやりとりができます。
                        </li>
                    </ol>
                    <div className="my-16 md:my-24" />
                    <div className="fixed bottom-0 left-1/2 w-11/12 -translate-x-1/2">
                        <Button
                            onClick={() => navigate(Path.receivernickname)}
                            className="my-2 h-12 w-full"
                        >
                            家族を招待する
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};
